module.exports = __webpack_public_path__ + "img/Menu-15.c34e074f.png";